/**
 * Labstep
 */

import { PostFilter } from 'labstep-web/services/postFilter';
import { PostFilterComparison } from 'labstep-web/services/postFilter/constants';

export const PostFilterExperimentWorkflowResource = new PostFilter(
  [['guid', PostFilterComparison.eq]],
  'experiments.protocolValues.resource',
);

export const getPostFilterExperimentWorkflowResource = (
  path?: string,
) =>
  new PostFilter(
    [['guid', PostFilterComparison.eq]],
    path ? path : 'experiments.protocolValues.resource',
  );
